import { Notifications } from "@mui/icons-material";
import MenuIcon from '@mui/icons-material/Menu';
import SettingsIcon from '@mui/icons-material/Settings';
import { Badge, IconButton, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NotificationsComp from "../../Notifications/Notifications";
import { API } from "../../../lib/api";

const Header = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [notifications, setNotifications] = useState([]);    
    const handleSideBar = (event) => {
        event.preventDefault()
        let side = document.querySelector(".pc-sidebar")
        if (side.classList.contains('pc-sidebar-hide')) {
            side.classList.remove('pc-sidebar-hide')
            
        } else {
            side.classList.add('pc-sidebar-hide')
        }
        if (side.classList.contains("mob-sidebar-active")){
            side.classList.remove("mob-sidebar-active")
        } else {
            side.classList.add("mob-sidebar-active")
        }
    }

    const handleNotificationClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };    

    useEffect(() => {
        async function getData() {
            const response = await API.Notifications.FetchByUser(localStorage.id)
            setNotifications(response)
        }
        getData()
    },[])      

    return (
        <header className="pc-header">
            <div className="header-wrapper"> {/* [Mobile Media Block] start */}
            <div className="me-auto pc-mob-drp">
            <ul className="list-unstyled">
                {/* ======= Menu collapse Icon ===== */}
                <li className="pc-h-item pc-sidebar-collapse">
                    <a href="#!" className="pc-head-link ms-0" id="sidebar-hide" onClick={handleSideBar}>
                    <Tooltip title="Toggle Full Screen">
                        <MenuIcon/>
                    </Tooltip>
                    </a>
                </li>
                <li className="pc-h-item pc-sidebar-popup">
                    <a href="#!" className="pc-head-link ms-0" id="mobile-collapse" onClick={handleSideBar}>
                    <Tooltip title="Toggle Full Screen">
                        <MenuIcon/>
                    </Tooltip>
                    </a>
                </li>
                <li style={{display: "flex", alignItems: "center"}}>
                    <Link to="/settings" className="pc-head-link ms-0">
                    <Tooltip title="Settings">
                        <SettingsIcon/>
                    </Tooltip>
                    </Link>
                </li>
                <li style={{ display: "flex", alignItems: "center", marginLeft: "0.5em" }}>
                    <Tooltip title="View Notifications">
                        <IconButton onClick={handleNotificationClick}>
                            <Badge badgeContent={notifications.length} color="error">
                                <Notifications/>
                            </Badge>
                        </IconButton>
                    </Tooltip>
                </li>                
            </ul>
            </div>
            {/* [Mobile Media Block end] */}
            <NotificationsComp anchorEl={anchorEl} handleClose={handleClose} notifications={notifications} setNotifications={setNotifications} />
            </div>
        </header>
    )
}

export default Header
